<!--
 * @Descripttion:
 * @version:
 * @Author: Jianyong Wang
 * @Date: 2021-07-08 20:05:22
 * @LastEditors: zhangyang yang.zhang@corerain.com
 * @LastEditTime: 2023-03-22 11:10:11
-->
<template>
  <a-layout-sider v-model:collapsed="collapsed" :trigger="null" width="224" collapsible>
    <a-menu
      :selected-keys="[activeMenu]"
      :open-keys="openMenu"
      mode="inline"
      theme="light"
      :inline-indent="Number(16)"
      :style="{ height: '100%', borderRight: 0 }"
    >
      <template v-for="item in list" :key="item.path">
        <a-sub-menu v-if="item.children && item.children.length" :key="item.path">
          <template #title>
            <span>
              {{ item.meta && item.meta.title }}
              <!-- {{ item.path }} -->
              <!-- <router-link :to="item.path">{{ item.meta && item.meta.title }}</router-link> -->
            </span>
          </template>

          <AsideBar :list="item.children" :show-foot="false"></AsideBar>
        </a-sub-menu>
        <a-menu-item
          v-if="!item.children && !item.meta.isHideMenu"
          :key="item.path"
          @click="handleOpenUrl(item.meta.openURL)"
        >
          <template #icon>
            <span v-if="item.path === activeMenu" class="ant-menu-item-icon">
              <svg-icon
                class="icon translate-c"
                :name="`${item.meta.icon.substring(0, item.meta.icon.indexOf('-def'))}-act`"
              />
              <svg-icon
                class="icon translate-c"
                :name="`icon-${item.meta.icon.substring(0, item.meta.icon.indexOf('-def'))}-act`"
              />
            </span>
            <span v-else class="ant-menu-item-icon">
              <svg-icon class="icon translate-c" :name="item.meta.icon" />
              <svg-icon :name="`icon-${item.meta.icon}`"></svg-icon>
            </span>
          </template>
          <router-link v-if="!item.meta.openURL" :to="item.path">{{ item.meta.title }}</router-link>
          <span v-else>{{ item.meta.title }}</span>
        </a-menu-item>
      </template>
    </a-menu>
    <div v-if="showFoot" class="footer">
      <span
        v-if="collapsed"
        class="icon-button anticon flex-c"
        @click="() => (collapsed = !collapsed)"
      >
        <svg-icon class="menu-icon app-menu" name="icon-unfold" />
      </span>
      <span v-else class="icon-button anticon flex-c" @click="() => (collapsed = !collapsed)">
        <svg-icon class="menu-icon app-menu" name="icon-fold" />
      </span>
    </div>
  </a-layout-sider>
</template>

<script lang="ts">
import { defineComponent, ref, PropType, computed, toRefs, onMounted, onUpdated } from 'vue'
import { IRouteItem } from '@/router/types.d'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'

export default defineComponent({
  name: 'AsideBar',
  props: {
    list: {
      type: Array as PropType<IRouteItem[]>,
      // eslint-disable-next-line vue/require-valid-default-prop
      default: () => []
    },
    showFoot: {
      type: Boolean,
      default: false
    }
  },
  emits: ['open'],
  setup(props, context) {
    const { list } = toRefs(props)
    const { emit } = context
    const isCollapse = ref(false)

    const store = useStore()

    const toggleSidebar = () => {
      isCollapse.value = !isCollapse.value
    }

    const router = useRoute()
    const activeMenu = computed(() => {
      if (router.path.indexOf('/online-shop/app-shop-detail') !== -1) {
        return '/online-shop/app-store'
      } else if (
        router.path.indexOf('/application-management/license-detail') !== -1 ||
        router.path.indexOf('/application-management/add-license') !== -1
      ) {
        return '/application-management/auth'
      } else if (router.path.indexOf('online-shop/algorithm-detail') !== -1) {
        return '/online-shop/algorithm-shop'
      } else if (router.path.indexOf('/application-management/app-detail') !== -1) {
        return '/application-management/remote-application'
      } else {
        return router.path
      }
    })
    const openMenu = computed(() => [
      list.value && list.value.length
        ? list.value.filter(
            (item) =>
              (item.children && item.children.length) || (!item.children && !item.meta.isHideMenu)
          )[0].path
        : ''
    ])
    const handleOpenUrl = async (url) => {
      if (url) {
        // const ipHost = 'http://localhost:3000'
        let ipHost = store.state.user.internalIp
        const userToken = store.state.user.token

        if (!ipHost) {
          await store.dispatch('user/saveIntervalIp')
          ipHost = store.state.user.internalIp
          const realUrl = `${ipHost}/${url}?userToken=${userToken}`
          window.open(realUrl)
          return false
        }
        const realUrl = `${ipHost}/${url}?userToken=${userToken}`
        window.open(realUrl)
      }
    }

    return {
      handleOpenUrl,
      isCollapse,
      toggleSidebar,
      collapsed: ref<boolean>(false),
      activeMenu,
      openMenu
    }
  }
})
</script>

<style lang="less">
@import url('@/styles/params.less');
.ant-layout-sider-children {
  overflow: hidden auto;
}
.ant-layout-sider {
  // box-shadow: 0 2px 4px 1px rgba(46, 48, 51, 0.1), 0 0 8px 1px rgba(24, 25, 26, 0.1);
  background: #f5f7fa;

  .ant-layout-sider-children {
    display: flex;
    flex-direction: column;

    .ant-menu-root {
      padding: 0;
      flex: 1;
      overflow: hidden auto;
      background-color: #f5f7fa;

      .ant-menu-item {
        margin-bottom: 8px;
        border-radius: 1px;
        margin-top: 0;
        padding-left: 18px !important;
        .ant-menu-title-content {
          a {
            color: @sidebarMenu-children-text-color;
          }
        }
      }
      .ant-menu-item.ant-menu-item-selected {
        .ant-menu-title-content {
          a {
            color: @sidebarMenu-text-color-active;
          }
        }
      }

      .ant-menu-submenu.ant-menu-submenu-open {
        .ant-menu-submenu-title {
          color: @sidebarMenu-subMenu-open-text-color;
        }
        .ant-menu-submenu-arrow {
          color: #595959;
        }
      }
      .ant-menu-submenu {
        border-bottom: 1px solid #e9ecf2;
        .ant-menu-submenu-title {
          margin: 0;
        }
        .ant-menu-submenu-arrow {
          color: #a6a6a6;
        }
      }

      .ant-menu-submenu-title:active {
        background: rgba(0, 0, 0, 0);
      }
      .ant-menu-submenu:hover {
        .ant-menu-submenu-title {
          color: @sidebarMenu-subMenu-open-text-color;
        }
      }
    }
  }

  .ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected {
    background: #e1e8fa;
    border-radius: 2px;
    a {
      font-size: 14px;
      font-weight: 400;
      color: #005bff;
    }
  }

  .ant-menu-item-icon {
    height: 40px;
  }

  .footer {
    width: 100%;
    height: 56px;
    line-height: 56px;
    border-top: 1px solid rgba(0, 0, 0, 0.15);
    display: flex;
    align-items: center;
    justify-content: flex-end;

    .anticon {
      width: 32px;
      height: 32px;
      border: 1px solid rgba(0, 0, 0, 0.15);
      margin-right: 18px;
      cursor: pointer;
      border-radius: 100%;

      &:hover {
        border-color: #005bff;
        color: #005bff;
      }

      svg {
        width: 20px;
        height: 20px;
      }
    }
  }

  .ant-menu-root {
    padding: 8px;
    box-sizing: border-box;
  }

  .ant-layout-sider-trigger {
    position: absolute;
  }
}

.ant-menu-inline-collapsed-tooltip {
  a {
    color: #fff;
  }
}

.ant-menu.ant-menu-inline-collapsed > .ant-menu-item .ant-menu-item-icon {
  display: block;
  margin: 0 auto;
}

.ant-menu.ant-menu-inline-collapsed > .ant-menu-item,
.ant-menu.ant-menu-inline-collapsed
  > .ant-menu-item-group
  > .ant-menu-item-group-list
  > .ant-menu-item,
.ant-menu.ant-menu-inline-collapsed
  > .ant-menu-item-group
  > .ant-menu-item-group-list
  > .ant-menu-submenu
  > .ant-menu-submenu-title,
.ant-menu.ant-menu-inline-collapsed > .ant-menu-submenu > .ant-menu-submenu-title {
  width: 40px;
  margin: 0 auto;
  padding: 0;
  text-align: center;
}

.ant-layout-sider-collapsed {
  width: 56px !important;
  max-width: 56px !important;
  min-width: 56px !important;

  .footer {
    justify-content: center !important;

    .anticon {
      margin-right: 0;
    }
  }
}
</style>
